var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Realizado Empresas nos Anos "+_vm._s(_vm.filters.ano_ref - 1)+"/"+_vm._s(_vm.filters.ano_ref))]),_c('v-card-text',[_c('Chart',{attrs:{"chartOptions":_vm.chartOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }